export const cookieNames = {
  token: 'LANDLORDACCESSSESSION',
  role: 'USERROLE',
  level: 'ACCOUNTLEVEL',
  landlordName: 'LANDLORDNAME',
  landlordSlug: 'LANDLORDSLUG',
  landlordContact: 'LANDLORDCONTACT',
  agentToken: 'AGENTACCESSSESSION',
};

export const storageNames = {
  paymentsetupProperties: 'PAYMENTSETUPPROPERTIES',
};
